import { render } from "./index.vue?vue&type=template&id=75c5d8c2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=75c5d8c2&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c5d8c2"]])

export default __exports__